<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g id="files-and-folders">
      <path
        id="Path_471"
        data-name="Path 471"
        d="M9.475,0H1.828A1.83,1.83,0,0,0,0,1.834V12.171a1.83,1.83,0,0,0,1.828,1.834H6.21a5.838,5.838,0,0,1-.559-2.5A5.779,5.779,0,0,1,6.071,9.33a.35.35,0,0,1-.086.007H2.66A.667.667,0,0,1,2.66,8H5.984a.657.657,0,0,1,.585.36A5.879,5.879,0,0,1,8.218,6.669H2.66a.667.667,0,0,1,0-1.334H8.644A.668.668,0,0,1,9.309,6a.353.353,0,0,1-.007.087,5.557,5.557,0,0,1,2-.413V1.834A1.83,1.83,0,0,0,9.475,0ZM5.319,4H2.66a.667.667,0,0,1,0-1.334h2.66A.667.667,0,0,1,5.319,4Z"
      />
      <path
        id="Path_472"
        data-name="Path 472"
        d="M14.988,10.5a4.488,4.488,0,1,0,4.488,4.488A4.493,4.493,0,0,0,14.988,10.5Zm1.828,5.153H15.653v1.164a.665.665,0,1,1-1.33,0V15.653H13.16a.665.665,0,0,1,0-1.33h1.164V13.16a.665.665,0,0,1,1.33,0v1.164h1.164a.665.665,0,1,1,0,1.33Z"
        transform="translate(-3.476 -3.476)"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "add-contract",
};
</script>

<style scoped></style>
